export default __webpack_public_path__ + "static/media/cake-6.2425baa4.svg";